export default {
  NONE: 'none',
  USER_COURSE: 'user_course'
}
